const getSortFn = (sortBy, order = 'desc') => {
  const factor = order === 'desc' ? 1 : -1
  return (a, b) => factor * (b[sortBy] - a[sortBy])
}

export default getSortFn